'use client'
import React, { useMemo } from 'react'
import styles from './styles.module.scss'

export type Value = string

interface IPresetOption {
  value: number | string
  label: string
}

interface ButtonGroupProps {
  options?: IPresetOption[]
  onClick?: (value: number | string) => void
  value: number | string
}

function ButtonGroup<T extends Value>({
  options,
  onClick,
  value,
}: ButtonGroupProps) {
  const itemWidth = useMemo(
    () => (options ? 100 / options.length : 0),
    [options],
  )

  if (!options) return null

  return (
    <div className={styles.container}>
      {options.map(valueItem => (
        <div
          style={{ flex: `1 1 ${itemWidth}%` }}
          className={`${styles.item} ${
            Number(value) === Number(valueItem.value) ? styles.active : ''
          }`}
          key={`${valueItem.value}_${valueItem.label}`}
          onClick={() => onClick && onClick(Number(valueItem.value))}
        >
          <div className={styles.label}>{valueItem.label}</div>
        </div>
      ))}

      <div className={styles.border} />
    </div>
  )
}

export default React.memo(ButtonGroup)
